// CMS responses frozen into the bundle by `npm run cms:snapshot`, one file per
// API route (`/api/skills` -> ./data/skills.json). Typed `unknown` on purpose:
// they are not trusted here, the client parses them against libs/contract
// exactly as it parses a live response.
const files = import.meta.glob<unknown>('./data/*.json', {
  eager: true,
  import: 'default',
});

const jsonResponse = (status: number, body: unknown) =>
  new Response(JSON.stringify(body), {
    status,
    headers: { 'Content-Type': 'application/json' },
  });

const pathOf = (input: RequestInfo | URL): string => {
  const href =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input.url;
  // The client is given an empty baseUrl, so requests arrive root-relative.
  return new URL(href, 'http://snapshot.invalid').pathname;
};

/**
 * A `fetch` that answers the portfolio client from the snapshot instead of the
 * network. Plugging it into the existing `fetch` seam keeps the whole pipeline
 * (envelope + zod parse, 404 -> null, mappers) identical to the live path.
 *
 * Mirrors Strapi's answers: `{ data }` for a route with content, and a 404 for
 * a single type with no entry or a route that does not exist.
 */
export const snapshotFetch: typeof fetch = async (input) => {
  const route = /^\/api\/([^/]+)$/.exec(pathOf(input))?.[1];
  const data = route === undefined ? undefined : files[`./data/${route}.json`];

  if (data === undefined || data === null) {
    return jsonResponse(404, {
      data: null,
      error: { status: 404, name: 'NotFoundError', message: 'Not Found' },
    });
  }
  return jsonResponse(200, { data });
};
